<template>
    <div class="components">
        <div class="back_btn row_center" @click="backTop">回到顶部</div>
    </div>
</template>

<script>
    export default {
        name: "backTopBtn",
        data() {
            return {
                scrollTop: 0,
            }
        },
        mounted() {
            window.addEventListener('scroll',this.scrollToTop)
        },
        methods: {
            backTop () {
                const that = this
                let timer = setInterval(() => {
                    let ispeed = Math.floor(-that.scrollTop / 5)
                    document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
                    if (that.scrollTop === 0) {
                        clearInterval(timer)
                    }
                }, 16)
            },
            // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
            scrollToTop () {
                const that = this
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
                that.scrollTop = scrollTop
                if (that.scrollTop > 60) {
                    that.btnFlag = true
                } else {
                    that.btnFlag = false
                }
            }
        }
    }
</script>

<style scoped>
    .back_btn {
        width: 89px;
        height: 36px;
        background: #262626;
        border-radius: 2px;
        font-size: 14px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        line-height: 20px;
        color: #FFFFFF;
        margin-left: 20px;
    }
</style>
